"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const AuthContext_1 = __importDefault(require("../contexts/AuthContext"));
function useAuth() {
    return (0, react_1.useContext)(AuthContext_1.default);
}
exports.default = useAuth;
